export const PAYMENT_STATUS_JUST_DONE = 'just_done';
export const PAYMENT_STATUS_DONE = 'done';
export const PAYMENT_STATUS_PENDING = 'pending';
export const PAYMENT_STATUS_EXPIRED = 'expired';
export const PAYMENT_STATUS_INIT_FAILING = 'init_failing';
export const PAYMENT_STATUS_BOOKING_CANCELLED = 'cancelled';
